import Cookies from "js-cookie";

// The "notify me when available" request a customer started while logged out.
// It survives the trip through the login page so the product page can finish
// the request instead of making them click the button all over again.
const COOKIE_NAME = "pending_stock_alert";

function saveStockAlertIntent(productId) {
    if (!productId) {
        return;
    }

    Cookies.set(COOKIE_NAME, String(productId));
}

// Returns the product id the intent was saved for, or an empty string
function readStockAlertIntent() {
    return Cookies.get(COOKIE_NAME) || "";
}

function clearStockAlertIntent() {
    Cookies.remove(COOKIE_NAME);
}

// Tells whether a saved intent belongs to the product currently on screen —
// the intent is one-shot, so anything else must be ignored, not replayed.
function hasStockAlertIntentFor(productId) {
    return Boolean(productId) && readStockAlertIntent() === String(productId);
}

export {
    saveStockAlertIntent,
    readStockAlertIntent,
    clearStockAlertIntent,
    hasStockAlertIntentFor
};
